import { PeriodicityTypes } from './periodicity-types';

export const PERIODICITY_TYPE_LABEL_MAP: Record<PeriodicityTypes, string> = {
  [PeriodicityTypes.Daily]: 'День',
  [PeriodicityTypes.Weekly]: 'Тиждень',
  [PeriodicityTypes.Monthly]: 'Місяць',
  [PeriodicityTypes.Once]: 'Одноразово',
};
